<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2559 0.410826C15.5814 0.736263 15.5814 1.2639 15.2559 1.58934L6.08925 10.756C5.93297 10.9123 5.72101 11.0001 5.5 11.0001C5.27899 11.0001 5.06702 10.9123 4.91074 10.756L0.744078 6.58934C0.418641 6.2639 0.418641 5.73626 0.744078 5.41083C1.06951 5.08539 1.59715 5.08539 1.92259 5.41083L5.5 8.98824L14.0774 0.410826C14.4028 0.0853889 14.9305 0.0853888 15.2559 0.410826Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "Centang",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
